import React from 'react';

export const Google30x30 = ({ width = 30, height = 30 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
  >
    <g clipPath="url(#clip0_32059_111862)">
      <path
        d="M26.7143 15.2261C26.7143 14.2429 26.6345 13.5253 26.4619 12.7812H15.2339V17.2192H21.8245C21.6916 18.3221 20.9741 19.9831 19.3796 21.0992L19.3572 21.2478L22.9073 23.998L23.1532 24.0225C25.4121 21.9363 26.7143 18.8669 26.7143 15.2261Z"
        fill="#4285F4"
      />
      <path
        d="M15.234 26.9139C18.4628 26.9139 21.1734 25.8508 23.1533 24.0172L19.3797 21.0939C18.3698 21.7981 17.0145 22.2898 15.234 22.2898C12.0716 22.2898 9.38751 20.2037 8.43072 17.3203L8.29048 17.3322L4.59906 20.189L4.55078 20.3232C6.51732 24.2297 10.5567 26.9139 15.234 26.9139Z"
        fill="#34A853"
      />
      <path
        d="M8.43041 17.3228C8.17796 16.5787 8.03185 15.7814 8.03185 14.9576C8.03185 14.1338 8.17796 13.3365 8.41713 12.5924L8.41044 12.434L4.67276 9.53125L4.55047 9.58942C3.73997 11.2105 3.2749 13.0309 3.2749 14.9576C3.2749 16.8843 3.73997 18.7047 4.55047 20.3258L8.43041 17.3228Z"
        fill="#FBBC05"
      />
      <path
        d="M15.234 7.62403C17.4795 7.62403 18.9943 8.59401 19.858 9.40461L23.233 6.10928C21.1602 4.1826 18.4628 3 15.234 3C10.5567 3 6.51732 5.68406 4.55078 9.59056L8.41744 12.5936C9.38751 9.7102 12.0716 7.62403 15.234 7.62403Z"
        fill="#EB4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_32059_111862">
        <rect width="24" height="24" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);
